<template>
  <IndicatorWrapper class="commercial-pulse" :status="status" v-if="visible">
    <div class="top">
      <TextWithFilters ref="textComponent" textKey="commercial_pulse_text_with_filters" :textData="dynamicTextData" v-model="currentFilters"></TextWithFilters>
    </div>
    <div class="bottom">
      <PulseChart :data="indicatorData.evolutive" :status="evolutiveStatus" :sector="currentFilters.sector_pulse" :compareData="indicatorData.compare_data"></PulseChart>
      <ChartLegend :items="legendItems" v-show="isCompareMode" type="line"></ChartLegend>
      <ChartDescription :values="currentFilters" :indicator="indicator" descriptionKey="commercial_pulse_info"></ChartDescription>
    </div>
  </IndicatorWrapper>
</template>

<script>
import Api from '@/api'
import indDynamicText from '@/mixins/indDynamicText'
import indData from '@/mixins/indData'
import TextWithFilters from '@/components/IndicatorCards/parts/TextWithFilters'
import PulseChart from '@/components/IndicatorCards/parts/charts/PulseChart'
import ChartDescription from '@/components/IndicatorCards/parts/ChartDescription'
import ChartLegend from '@/components/IndicatorCards/parts/ChartLegend'

import IndicatorWrapper from '@/components/IndicatorCards/parts/IndicatorWrapper'
export default {
  name: 'CommercialPulse',

  mixins: [indData, indDynamicText],

  components: {
    TextWithFilters,
    ChartDescription,
    ChartLegend,
    PulseChart,
    IndicatorWrapper
  },
  computed: {
    evolutiveStatus () {
      // return (!this.indicatorData['evolutive'] || this.$asyncComputed['asc_evolutive'].updating) ? {status:'fetching'} : {status:'ready'}
      if(this.$asyncComputed['asc_evolutive'].updating) return {status:'fetching'}
      else if(!this.indicatorData['evolutive']) return {status:'no-data'}
      else return {status:'ready'}
    },
    indicatorData() {
      return {
        main_value: {
          required: true,
          get () {
            return Api.getIndicatorData('ind_pulse',this.currentFilters)
          }
        },
        evolutive: {
          required: false,
          get () {
            // UGLY - But in all other cases the "all sectors" has a null key, should be changed by server
            if(this.currentFilters.group_pulse == 'commerce-sector-total') {
              this.currentFilters.group_pulse = ''
            }
            return Api.getIndicatorData('evol_pulse', this.currentFilters)
          }
        },
        compare_data: {
          required: false,
          triggers_jump: false,
          get () {
            return this.isCompareMode ? Api.getIndicatorData('evol_pulse',this.currentFilters, {
              node: this.compareNodeInfo,
              avoidCancel: true
            }) :
            Promise.resolve(false)
          }
        }
      }
    },
    dynamicTextData () {
      return [
        {
          type: 'select',
          id: 'group_pulse',
        },
        {
          type: 'value',
          id: 'VALUE_1',
          value: this.indicatorData.main_value && this.indicatorData.main_value.data[0] && this.indicatorData.main_value.data[0].value,
          unit: '%'
        },
        {
          type: 'value',
          id: 'VALUE_2',
          value: this.indicatorData.main_value && this.indicatorData.main_value.data[1] && this.indicatorData.main_value.data[1].value,
          unit: '%'
        }
      ]
    },
  }
}
</script>

<style lang="stylus" scoped>
.commercial-pulse
  .pulse-chart
    .mobile &
      margin auto 0
      margin-top vh(10px)
      flex 0 0 vh(220px)
</style>